import React , { useState, useEffect } from 'react';
import './header.scss';
import company from '@visit/images/company.png';
import phoneIcon from '@visit/images/phoneIcon.png';
import userIcon from '@visit/images/user-icon.png';
import homePhone from '@company/images/home-phone.png'
import homeTime from '@company/images/home-time.png'

function HomeHeader(props) {

  const goRegister = () => {
    window.location.href = 'https://www.001pt.com/login/register.html';
  }

  const goIndex = () => {
    window.location.href = 'https://www.001pt.com/';
  }

  return (
    <header className="home-header">
        <div className="header-left">
            <img alt="" src={company}/>
        </div>
        <div className="header-right">
            <div className="nav-item" onClick={goIndex}>
              <span>首页</span>
            </div>
            <div className="nav-item">
              <img className="phone-icon" src={phoneIcon} />
              <span>联系客服</span>
              <div className="phone-text-box">
                  <div style={{borderBottom:"1px solid #eee",paddingBottom:"10px",marginBottom:"10px"}}>
                      <p style={{color:"#666"}}><img src={homePhone} />全国统一热线咨询:</p>
                      <p style={{marginLeft:"26px", color:"#333",fontSize: "20px",fontFamily: 'Arial'}}><b>400-6657-688</b></p>
                      <span className="tell-user-iphone" onClick={()=>{
                        if(window.qimoChatClick){
                          window.qimoChatClick()
                        }
                      }}>在线客服咨询</span>
                  </div>
                  <div>
                      <p style={{color:"#666"}}><img src={homeTime}/>工作时间:</p>
                      <p style={{marginLeft:"26px", color:"#333",fontFamily: 'Arial'}}>周一到周五 <b>8:30 - 18:00</b></p>
                  </div>
              </div>
            </div>
            <div className="nav-item" onClick={goRegister}>
              <img className="user-icon" src={userIcon} />
              <span>注册</span>
            </div>
        </div>
    </header>
  );
}
export default HomeHeader;
